import React from 'react';
import { Badge, ButtonSelect } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import './SmartFilterButtonSelect.css';

function SmartFilterButtonSelect({
  ariaLabel,
  isOpen,
  setIsOpen,
  label,
  showBadge,
  prefixIcon,
}) {
  return (
    <div className='SmartFilterButtonSelect-wrapper'>
      <ButtonSelect
        ariaLabel={ariaLabel}
        kind='pill'
        size='medium'
        className={`SmartFilterButtonSelect-button ${
          isOpen
            ? 'SmartFilterButtonSelect-button SmartFilterButtonSelect-button--IsOpen'
            : ''
        }`}
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        label={label}
        prefixIcon={prefixIcon}
        BadgeComp={
          showBadge ? <Badge kind='dot' color='primary' size='small' /> : null
        }
        isIconSvgFilled={false}
      />
    </div>
  );
}

SmartFilterButtonSelect.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  showBadge: PropTypes.bool.isRequired,
  prefixIcon: PropTypes.node.isRequired,
};

export default SmartFilterButtonSelect;
